// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".farmacia-entradas-container[data-v-6f7076a4]{padding:20px}", ""]);
// Exports
module.exports = exports;
